import { render, staticRenderFns } from "./update-registration-page.vue?vue&type=template&id=7246ba4d&scoped=true&"
import script from "./update-registration-page.vue?vue&type=script&lang=js&"
export * from "./update-registration-page.vue?vue&type=script&lang=js&"
import style0 from "./update-registration-page.vue?vue&type=style&index=0&id=7246ba4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246ba4d",
  null
  
)

export default component.exports